import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  schedule: null,
};

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    setSchedule: (state, { payload }) => {
      state.schedule = payload.schedule;
    },
    clearSchedule: (state) => {
      state.schedule = null;
    },
    deleteScheduleEvent: (state, { payload }) => {
      const { scheduleEvent } = payload;
      state.schedule.scheduleEvents = state.schedule.scheduleEvents.filter(
        (event) => event.id !== scheduleEvent.id
      );
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSchedule, clearSchedule, deleteScheduleEvent } =
  scheduleSlice.actions;
